(() => {
    const message = document.getElementById('shipping-announcement-message');

    if (!message) return;

    const threshold = 400000;

    const formatPrice = (amount) => {
        return Math.round(amount / 100).toLocaleString('ja-JP');
    };

    const updateDisplay = (total) => {
        const remaining = Math.max(0, threshold - total);

        message.textContent = remaining === 0
            ? '送料無料で配送いたします！🎁'
            : `あと${formatPrice(remaining)}円で送料無料`;
    };

    let requestId = 0;

    const updateCart = async () => {
        const id = ++requestId;

        try {
            const root = window.Shopify?.routes?.root || '/';

            const response = await fetch(`${root}cart.js`, {
                cache: 'no-store'
            });

            if (!response.ok) return;

            const cart = await response.json();

            if (id === requestId) {
                updateDisplay(cart.total_price);
            }
        } catch (error) {
            console.error('Shipping announcement:', error);
        }
    };

    const originalFetch = window.fetch;

    window.fetch = async function (...args) {
        const response = await originalFetch.apply(this, args);
        const input = args[0];
        const url = typeof input === 'string' ? input : input?.url || '';

        if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/.test(url) && response.ok) {
            setTimeout(updateCart, 100);
        }

        return response;
    };

    document.addEventListener('cart:refresh', updateCart);
    document.addEventListener('cart:change', updateCart);
    document.addEventListener('cart:updated', updateCart);

    document.addEventListener('visibilitychange', () => {
        if (!document.hidden) updateCart();
    });

    updateCart();
})();